export default __webpack_public_path__ + "static/media/zahrada-sk-for-light-background.06941e64.svg";